/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export const noop = () => {};
export const noopEmptyObject = () => ({});
export const noopUndefined = (): undefined => undefined;

/**
 * This function is intended to be used in test files.
 */
export const flushPromiseQueue = async () => new Promise(resolve => setTimeout(resolve, 0));

/**
 * This function is intended to be used in test files.
 */
export const mockDate = (date: Date) => {
    const originalDate = Date;
    (<any>global).Date = jest.fn(() => date);
    (<any>global).Date.now = jest.fn(() => date.getTime());

    return () => {
        (<any>global).Date = originalDate;
    };
};

export const tryParseJson = <T>(value: string): T | undefined => {
    try {
        return JSON.parse(value);
    } catch {
        return undefined;
    }
};

export const isNullOrUndefined = <T>(value: T | null | undefined): value is null | undefined => value === null || value === undefined;
